let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hsogV")).then(() => parcelRequire('1IIuQ'));